import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {ConfService} from '../conf.service';
import {AccountInfoService} from '../user/account-info.service';

@Component({
  selector: 'app-connectorlist',
  templateUrl: './connectorlist.component.html',
  styleUrls: ['./connectorlist.component.scss']
})
export class ConnectorlistComponent implements OnInit {
    apiList_copy: any;

  constructor(private route: ActivatedRoute, private confPost: ConfService, private accountInfoService: AccountInfoService) { }
  arrayList = [];
  @Input() connectorName: any;
  selected_executor: any;
  selected_version: any;
  flag = false;
    itemList = [
        {
            filter: "executor_name",
            id: 0,
            itemName: "API Name"
        },
        {
            filter: "category",
            id: 1,
            itemName: "API Category"
        },
        {
            filter: "executor_version",
            id: 2,
            itemName: "API Version"
        },
        {
            filter: "executor_method_type",
            id: 3,
            itemName: "API Method"
        }
    ];
    filterData: any[] = [
        {
            filter: "executor_name",
            id: 0,
            itemName: "API Name"
        },
        {
            filter: "category",
            id: 1,
            itemName: "API Category"
        },
        {
            filter: "executor_version",
            id: 2,
            itemName: "API Version"
        },
        {
            filter: "executor_method_type",
            id: 3,
            itemName: "API Method"
        }
    ];
    searchFlag = false;
    applicationFilterData: any[];
    searchText: string;
    applicationSearchText: string;
    advancedSearch: false;
    settings = {
        text: 'Select attribute(s) to search',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
  ngOnInit() {
        if (this.connectorName) {
           this.b2bServiceProviders().then(() => {
               if (this.accountInfoService.partner !== 'b2b') {
                   this.nonb2bServiceProviders();
               }
           });
        }
        this.apiList_copy = [];
  }
  changeExecutor(val) {
      this.selected_executor = val;
  }

  b2bServiceProviders() {
      return new Promise((resolve, reject) => {
          this.confPost.getPartnerAccountServiceProviderCategorybyGroup('b2b', 'b2b', this.connectorName).subscribe(result => {
              this.flag = true;
              const iterator = result[Symbol.iterator]();
              while (true) {
                  const tempObject = iterator.next();
                  if (tempObject.done) {
                      break;
                  }
                  this.arrayList.push(tempObject.value);
              }
              if (this.arrayList !== null && this.arrayList.length > 0) {
                  this.selected_executor = this.arrayList[0]['executors'][0];
              }
              resolve('success');
          }, error => {
              resolve('failed');
          });
      });
  }

  nonb2bServiceProviders() {
      return new Promise((resolve, reject) => {
          this.confPost.getPartnerAccountServiceProviderCategorybyGroup(this.accountInfoService.partner, this.accountInfoService.account, this.connectorName).subscribe(result => {
              this.flag = true;
              const iterator = result[Symbol.iterator]();
              while (true) {
                  const tempObject = iterator.next();
                  if (tempObject.done) {
                      break;
                  }
                  this.arrayList.push(tempObject.value);
              }
              if (this.arrayList !== null && this.arrayList.length > 0) {
                  this.selected_executor = this.arrayList[0]['executors'][0];
              }
              resolve('success');
          }, error => {
              resolve('failed');
          });
      });
  }

  checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
        alert('Please select an attribute to filter.');
        this.searchText = '';
        }
    }
    
    getFilteredArray(e){
        const filterValue = e.toLowerCase();
        this.apiList_copy = [];
        // console.log(filterValue);
        let temp = this.arrayList;
        let tempVar: any;
        if (filterValue){
            this.searchFlag = true;
            temp = temp.filter((option) => {
                let flag = 0;
                let tempList = [];
                option['executors'].filter((executor) => {
                    // console.log('executor-> ', executor);
                    if(option['category'].toLowerCase().includes(filterValue)|| executor['executor_name'].toLowerCase().includes(filterValue)|| executor['executor_method_type'].toLowerCase().includes(filterValue)||executor['executor_version'].toLowerCase().includes(filterValue)){
                        tempList.push(executor);
                        flag = 1;
                    }
                });
                if (flag === 1) {
                    tempVar = {'category' :option['category'], 'executors': tempList};
                    this.apiList_copy.push(tempVar);
                }
            });
        }
        else{
            this.searchFlag = false;
        }
    }
}
